import React, { useEffect, useRef } from "react";
import Avatar from "../Avatar";
import { ChatBubble, TypingDots } from "./ChatBubble";

// Scrollable message list with empty-state suggestions and the typing
// indicator. Auto-scrolls to the bottom on every new message.
export function ChatMessages({ messages, loaded, sending, botName, avatarStyle, avatarSkin, mood, onSuggest }) {
    const scrollRef = useRef(null);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [messages, sending]);

    return (
        <div ref={scrollRef} className="flex-1 overflow-y-auto px-3 py-4 space-y-3 min-h-[180px]">
            {messages.length === 0 && loaded && (
                <div className="text-center py-6 px-2">
                    <div className="inline-flex justify-center mb-2">
                        <Avatar mood="happy" size={72} style={avatarStyle} />
                    </div>
                    <p className="font-body text-sm text-warm-500 max-w-[230px] mx-auto">
                        Hi! I&apos;m {botName}. Tell me how your day&apos;s going, vent, or ask for a little nudge 🌸
                    </p>
                    <div className="flex flex-wrap gap-1.5 justify-center mt-4">
                        {["I need motivation", "How do I focus?", "Tell me a joke"].map((s) => (
                            <button
                                key={s}
                                onClick={() => onSuggest(s)}
                                className="text-xs font-body bg-surface hover:bg-surface-hover text-warm-800 px-3 py-1.5 rounded-full transition-all"
                                data-testid={`chat-suggest-${s.replace(/\s+/g, "-").toLowerCase()}`}
                            >
                                {s}
                            </button>
                        ))}
                    </div>
                </div>
            )}

            {messages.map((m) => (
                <ChatBubble key={m.id} role={m.role} text={m.text} actions={m.actions} avatarStyle={avatarStyle} avatarSkin={avatarSkin} mood={mood} />
            ))}

            {sending && (
                <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-surface flex items-center justify-center shrink-0">
                        <Avatar mood={mood} size={26} style={avatarStyle} skin={avatarSkin} />
                    </div>
                    <div className="bg-surface rounded-2xl rounded-bl-sm px-3 py-2.5">
                        <TypingDots />
                    </div>
                </div>
            )}
        </div>
    );
}
